import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { routes } from './setup/routes'
import App from './containers'
import { init } from './app'

import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey('22c63787ea6c94426cb68150a2c8bfb3Tz0xMjM4ODYsRT0xNzk5Mjc5OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=');

init().then(({ store, history }) => {
	const container = document.querySelector('#root')
	const root = createRoot(container)

	root.render(
		<Provider store={store}>
			<BrowserRouter>
				<App routes={routes} />
			</BrowserRouter>
		</Provider>
	)
})
